var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-chart-1"},[_c('div',{staticClass:"lc1-header"},[_vm._v("线下咨询服务")]),_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"offline"}})])
}]

export { render, staticRenderFns }